import { jsx } from "panel";
import isEmpty from "lodash/isEmpty";
import { DisplayPlotStyle } from "common/charts/visualization/line-chart/enums";
import { LineChartEl } from "common/charts/visualization/line-chart";
import { SpinnerEl } from "common/components/spinner";
import { SegmentLegendHeaderEl } from "common/charts/misc/segment-legend-header";
import { renderLineChartTooltip } from "common/report/insights/util/tooltip";
import { ContextMenuEl } from "common/widgets/context-menu";
import { EmptyDataEl } from "common/charts/misc/empty-data";
import { otherSegment as otherSegmentColors } from "common/util/colors";
import { canShowOtherSegment } from "common/report/insights/util";
import { renamePropertyValue } from "common/report/util/properties";
import {
  isFunnelConversionMetric,
  isFunnelTimeToConvertMetric,
  isRetentionConversionRateMetric
} from "common/report/insights/models/utils";
import { getLineSeries, getOtherSegmentData } from "./util";
export function template() {
  var _a;
  const loaded = this.attr(`loaded`) && this.hasRequiredParams() && this.state.lineChartData;
  if (!loaded) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".root"
    }, /* @__PURE__ */ jsx(SpinnerEl, {
      attrs: { elref: `loadingSpinner` }
    }));
  }
  if (isEmpty((_a = this.results) == null ? void 0 : _a.series)) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".root"
    }, /* @__PURE__ */ jsx(EmptyDataEl, null));
  }
  const { lineChartData } = this.state;
  const seriesLookup = /* @__PURE__ */ new Map();
  lineChartData.lineChartSeries.forEach((segment) => {
    const segmentKey = segment.name;
    if (!seriesLookup.has(segmentKey)) {
      seriesLookup.set(segmentKey, []);
    }
    seriesLookup.get(segmentKey).push(segment);
  });
  const visibleChartSeries = this.segmentFilterController.getSelectedItems(0).flatMap((item) => {
    return seriesLookup.get(item.id).map((segment) => ({
      ...segment,
      color: this.segmentFilterController.getItemColor(0, item.id)
    }));
  });
  let otherSegmentData;
  if (canShowOtherSegment(this.bookmarkParams)) {
    const allSegments = Array.from(lineChartData.segmentLookup.values());
    otherSegmentData = getOtherSegmentData(allSegments, this.segmentFilterController);
    if (!otherSegmentData.isAllZero) {
      visibleChartSeries.unshift(
        getLineSeries(
          otherSegmentData.percentagesSegment,
          otherSegmentColors.primary,
          this.getProjectTimezone(),
          this.results.meta.report_sections.show[0]
        )
      );
    }
  }
  if (lineChartData.chartPlotStyle === DisplayPlotStyle.Standard) {
    visibleChartSeries.reverse();
  }
  const visibleSegmentIds = visibleChartSeries.map((segment) => {
    return segment.name;
  });
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx(SegmentLegendHeaderEl, {
    sel: ".segment-legend-header",
    props: { visibleSegmentIds }
  }), /* @__PURE__ */ jsx(LineChartEl, {
    sel: ".line-chart",
    attrs: {
      elref: `lineChart`,
      "time-unit": lineChartData.chartTimeUnit,
      "incomplete-to-date": this.isEndDateIncomplete(),
      "display-analysis-type": lineChartData.chartAnalysisType,
      "display-plot-style": lineChartData.chartPlotStyle,
      "display-stacking-type": lineChartData.chartStackingType,
      "disable-area-range-mouse-tracking": this.hasForecastComparison(),
      "show-annotations": this.attr(`show-annotations`),
      "utc-offset": this.getProjectTimezone().utcOffset,
      timezone: this.getProjectTimezone().timezone,
      "y-axis-options": {
        softMin: isFunnelConversionMetric(this.bookmarkParams) || isFunnelTimeToConvertMetric(this.bookmarkParams) || isRetentionConversionRateMetric(this.bookmarkParams) ? 1 : 0
      },
      "zoom-type": `x`
    },
    props: {
      chartData: visibleChartSeries,
      formatTooltip: (_x, _y, _series, _seriesIdx, tooltipContext) => {
        const tooltipParams = this.generatePointTooltipParams(tooltipContext, otherSegmentData);
        return renderLineChartTooltip({
          ...tooltipParams,
          segments: tooltipParams.segments.map(
            (value, index) => renamePropertyValue(value, this.results.headers[index + 1])
          )
        });
      },
      formatYAxisLabel: this.formatYAxisLabel,
      onHighChartClick: this.popoverCallback && this.handlePointClick
    }
  }), this.state.popoverSelection && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ContextMenuEl, {
    attrs: {
      "menu-items": this.getPopoverAttrs()[`button-options`],
      "relative-positioning": true,
      open: true,
      position: { left: 0, top: 0 }
    },
    style: this.state.popoverStyles,
    on: {
      action: (ev) => this.handlePopoverAction(ev),
      close: () => this.handlePopoverClose()
    }
  })));
}
